<template>
  <form @submit="onSubmit">
    <div
      class="py-4 px-4 sm:px-8 bg-[#F9FAFC] w-full mt-8 flex flex-col gap-y-15 pt-8 rounded-md"
    >
      <!-- Design 1 Section -->
      <div class="flex flex-col gap-y-8">
        <div class="flex gap-x-2 items-center text-principal-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 512 512"
            class="h-7 w-7 sm:h-10 sm:w-10"
          >
            <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
            <path
              d="M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
            />
          </svg>
          <h3 class="text-xl sm:text-2xl text-black font-medium">Design 1</h3>
        </div>

        <div class="flex flex-col gap-y-6">
          <FileUploader
            v-model="cover1"
            v-bind="cover1Attrs"
            acceptedTypes="image/jpeg, image/png, image/jpg"
            :disabled="isFormDisabled"
          />
          <div class="flex flex-col gap-y-2">
            <label class="font-medium text-[#7B7979] text-base sm:text-lg"
              >Description</label
            >
            <Field name="descriptionCover1" v-slot="{ field, errors }">
              <textarea
                v-bind="field"
                placeholder="Describe the design concept and elements..."
                :class="{ 'ring-red-500 border-red-500': errors[0] }"
                :disabled="isFormDisabled"
              ></textarea>
            </Field>
            <ErrorMessage name="descriptionCover1" class="text-sm text-red-500" />
          </div>
        </div>
      </div>

      <!-- Design 2 Section -->
      <div class="flex flex-col gap-y-8 mt-8">
        <div class="flex gap-x-2 items-center text-principal-500">
          <svg
            class="h-7 w-7 sm:h-10 sm:w-10"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 512 512"
          >
            <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
            <path
              d="M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
            />
          </svg>
          <h3 class="text-xl sm:text-2xl text-black font-medium">Design 2</h3>
        </div>

        <div class="flex flex-col gap-y-6">
          <FileUploader
            v-model="cover2"
            v-bind="cover2Attrs"
            acceptedTypes="image/jpeg, image/png, image/jpg"
            :disabled="isFormDisabled"
          />
          <div class="flex flex-col gap-y-2">
            <label class="font-medium text-[#7B7979] text-base sm:text-lg"
              >Description</label
            >
            <Field name="descriptionCover2" v-slot="{ field, errors }">
              <textarea
                v-bind="field"
                placeholder="Describe the design concept and elements..."
                :class="{ 'ring-red-500 border-red-500': errors[0] }"
                :disabled="isFormDisabled"
              ></textarea>
            </Field>
            <ErrorMessage name="descriptionCover2" class="text-sm text-red-500" />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="flex flex-col w-full px-4 py-8 bg-[#EEF2FD] rounded-md mt-10">
      <h3 class="font-medium text-black text-lg sm:text-xl">
        Please ensure that both checkboxes are selected before submitting
      </h3>
      <div
        class="flex items-start gap-x-0 mt-4 flex-col sm:items-center gap-y-2 sm:flex-row sm:gap-y-2 sm:gap-x-2"
      >
        <div class="sm:contents flex items-center sm:items-start gap-x-2">
          <Field
            name="exclusiveSubmissionAgreement"
            type="checkbox"
            class="h-5 w-full max-w-[20px] cursor-pointer transition-all appearance-none rounded-md border border-slate-300 checked:bg-principal-500 checked:border-principal-500"
            id="exclusiveSubmissionAgreement"
            value="true"
            :disabled="isFormDisabled"
          >
          </Field>
          <label
            for="exclusiveSubmissionAgreement"
            class="text-sm sm:text-base text-black cursor-pointer ml-2"
          >
            I authorize the exclusive use of my work for internal purposes, including
            dataset creation for AI advancements.
          </label>
        </div>
        <ErrorMessage name="exclusiveSubmissionAgreement" class="text-sm text-red-500 text-center sm:text-start w-full" />
      </div>
    </div> -->

    <div class="flex justify-between w-full py-8 px-2 sm:px-0">
      <button @click="backStep" class="btn-secondary px-4 py-2" :disabled="isFormDisabled">Back</button>
      <!-- <ButtonComponent @click="onSubmit" :class="['btn-primary', 'flex', 'gap-y-2', 'items-center']" :loading="props.loading" :disabled="isFormDisabled"/> -->
      <button @click="onSubmit" class="btn-primary" :disabled="isFormDisabled">Next</button>
    </div>
  </form>
</template>

<script setup>
import { defineEmits, onMounted, defineProps, computed } from "vue";
import { useForm, ErrorMessage, Field } from "vee-validate";
import * as yup from "yup";
import FileUploader from "@/shared/component/FileUploader.vue";
// import ButtonComponent from "@/shared/component/ButtonComponent.vue";

const emit = defineEmits(["back", "next"]);
const props = defineProps({
  loading: Boolean,
})

// Computed property to determine if form should be disabled
const isFormDisabled = computed(() => props.loading);

const schema = yup.object({
  cover1: yup.mixed().required("File is required"),
  descriptionCover1: yup.string().required("Description is required").min(5, "Description must be at least 5 characters").max(500, "Description must be at most 500 characters"),
  cover2: yup.mixed().required("File is required"),
  descriptionCover2: yup.string().required("Description is required").min(5, "Description must be at least 5 characters").max(500, "Description must be at most 500 characters"),
 /*  exclusiveSubmissionAgreement: yup
    .boolean()
    .required("This field is required")
    .oneOf([true], "This field is required"), */
});

const { defineField, handleSubmit } = useForm({
  validateOnInput: true,
  validationSchema: schema,
});

const [cover1, cover1Attrs] = defineField("cover1", {
  props: (state) => ({ error: state.errors[0] }),
});

const [cover2, cover2Attrs] = defineField("cover2", {
  props: (state) => ({ error: state.errors[0] }),
});

const onSubmit = handleSubmit((values) => {
  emit("next", values);
});

const backStep = () => {
  emit("back");
};

onMounted(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});
</script>
